import { useMemo } from 'react';

import { useTranslation } from './useTranslation';

/**
 * Provides loading state messages for consistent translation
 * Used by LoadingFallback and SuspenseWithErrorBoundary components
 */
export function useLoadingMessages() {
  const { t } = useTranslation(['ui']);

  return useMemo(
    () => ({
      loading: t('ui:form.loading'),
    }),
    [t]
  );
}
